import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnSeasonPrice from "./HtlAgnSeasonPrice";
import HtlAgnOffres from "./HtlAgnOffres";
import HtlAgnQuota from "./HtlAgnQuota";
import HtlAgnGuarantee from "./HtlAgnGuarantee";
import HtlAgnFreeRooms from "./HtlAgnFreeRooms";


import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
query MyQuery12(
  $firmMainCode: String
  $firmSubCode: String
  $currentLocale: String
  $contIdSeq: Int!
  
) {
  tbl_cont_prn(order_by: { firm_main_code: asc },
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      id_seq: { _eq: $contIdSeq }
     
    }
  ) {
      firm_main_code
      firm_sub_code
      firm_sub_name {
        firm_sub_name
        int_ID
        
      }
      firm_sub_code_k
      firm_sub_name_k {
        firm_sub_name_n
      }

      
      id_seq
      active
      cont_type
      cont_type_k
      start_date
      end_date
      cont_group
      marketing
      currency
      status
      cont_desc
      dpr_main_code
      dpr_sub_code
      dpr_main_code_k
      dpr_sub_code_k      
      firm_main_code_k      
      get_main_firm_name_k {
        firm_main_name_n
      }
      create_user
      int_ID
      k_int_ID
      k_status
      created_at
      save_arr
      get_cont_type_name(where: { lang: { _eq: $currentLocale } }) {
        name
        lang
        type
      }
   
    }
  }

`;

const GET_FIRM_MAIN_COOP = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;






const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_CUR = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_MAR = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_MAIN_FIRM = gql`
  query MyQuery($firmMainCode: String!, $firmMainType: String) {
    tbl_firm_main(
      where: {
        firm_code: { _eq: $firmMainCode }
       
      }
    ) {
      firm_code
      firm_name
      firm_type
      ent_ID
    }
  }
`;

const GET_SUB_FIRM = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String) {
    tbl_firm_sub(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      firm_sub_name
      int_ID
    }
  }
`;

const GET_MAIN_DPR_M = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String) {
    tbl_dpr_main(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      dpr_main_code
      dpr_main_name
    }
  }
`;

const GET_MAIN_DPR_MK = gql`
  query MyQuery(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
    $firmSubCodeK: String)
     {
      tbl_dpr_main_coop(
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode },
        own_firm_sub_code: { _eq: $ownFirmSubCode },
        own_firm_sub_type: { _eq: $ownFirmSubType },
        firm_main_code_n: { _eq: $firmMainCodeK },
        firm_sub_code_n: { _eq: $firmSubCodeK },
       
      }
    ) {
      dpr_main_code_n
      dpr_main_name_n
      dpr_int_ID
      
    }
  }
`;

const GET_SUB_DPR_K = gql`
  query MyQuery(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
    $firmSubCodeK: String
    $dprMainMK: String!)
     {
      tbl_dpr_sub_coop(
      where: {
        own_firm_code: { _eq: $ownFirmMainCode },
        own_firm_sub_code: { _eq: $ownFirmSubCode },
        own_firm_sub_type: { _eq: $ownFirmSubType },
        firm_main_code_n: { _eq: $firmMainCodeK },
        firm_sub_code_n: { _eq: $firmSubCodeK },
        dpr_main_code_n: { _eq: $dprMainMK },
       
      }
    ) {
      dpr_sub_code_n
      dpr_sub_name_n
      dpr_sub_n_int_ID
      
    }
  }
`;

const GET_FIRM_MAIN_COOP_K = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        firm_main_code_n: { _eq: $firmMainCodeK }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;

const GET_FIRM_SUB_COOP_K = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
  ) {
    tbl_firm_sub_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        firm_main_code_n: { _eq: $firmMainCodeK }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      firm_sub_name_n
      firm_sub_type_n
      int_ID
    }
  }
`;

const GET_FIRM_SUB_COOP_K2 = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    
  ) {
    tbl_firm_sub_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      firm_sub_name_n
      firm_sub_type_n
      int_ID
    }
  }
`;

const GET_SUB_DPR_M = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String, $dprMainM: String) {
    tbl_dpr_sub(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        dpr_main_code: { _eq: $dprMainM },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      dpr_main_code
      dpr_sub_code
      dpr_sub_name
    }
  }
`;





const UPDATE_CONT = gql`
mutation UpdateContract(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $firmMainCodeK: String
  $firmSubCodeK: String
  $contType: String
  $contTypeK: String
  $contStatus: String
  $contGroup: String
  $startDate: date
  $endDate: date
  $market: String
  $currency: String
  $active: Boolean
  $mFIntId: Int
  $dprMainM: String
  $dprSubM: String
  $dprMainMK: String
  $dprSubMK: String
  $kFIntId: Int
  $saveArr: Int
  $contDesc: String
) {
  update_tbl_cont_prn(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      id_seq: { _eq: $contIdSeq }
    },
    _set: {
      cont_type: $contType,
      cont_type_k: $contTypeK,
      status: $contStatus,
      start_date: $startDate,
      end_date: $endDate,
      cont_group: $contGroup
      marketing: $market,
      currency: $currency,
      active: $active,
      int_ID: $mFIntId,
      dpr_main_code: $dprMainM,
      dpr_sub_code: $dprSubM,
      dpr_main_code_k: $dprMainMK,
      dpr_sub_code_k: $dprSubMK,
      firm_main_code_k: $firmMainCodeK,
      firm_sub_code_k: $firmSubCodeK,
      k_int_ID: $kFIntId,
      save_arr: $saveArr,
      cont_desc: $contDesc,
    }
  ) {
    affected_rows
  }
}
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_CONT = gql`
mutation InsertContract(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $firmMainCodeK: String
  $firmSubCodeK: String
  $contType: String
  $contTypeK: String
  $contStatus: String
  $startDate: date
  $endDate: date
  $active: Boolean
  $contGroup: String
  $market: String
  $currency: String
  
  $dprMainM: String
  $dprSubM: String
  $dprMainMK: String
  $dprSubMK: String
  $saveArr: Int
  $contDescc: String
 
  ) {
    insert_tbl_cont_prn(
      objects: {    
      
        id_seq: $contIdSeq,
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        firm_main_code_k: $firmMainCodeK,
        firm_sub_code_k: $firmSubCodeK,
        cont_type: $contType,
        cont_type_k: $contTypeK,
        status: $contStatus,
        start_date: $startDate,
        end_date: $endDate,
        active: $active,
        cont_group: $contGroup,
        marketing: $market,
        currency: $currency,
        save_arr: $saveArr,
        cont_desc: $contDescc,

        
        dpr_main_code: $dprMainM,
        dpr_sub_code: $dprSubM,
        dpr_main_code_k: $dprMainMK,
        dpr_sub_code_k: $dprSubMK,
       

  
      }
    ) {
      affected_rows
    }
  }
`;




const HtlAgnContractEdit = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode8, setVarCode8 } = useContext(ThemeContext);
  const { varCode4, setVarCode4 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  const { id_seq } = useParams();
  //setVarCode4(id_seq);
  
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };


  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, contIdSeq: id_seq, currentLocale: currentLocale },
  });



  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

 

 
  const [UpdateContract] = useMutation(UPDATE_CONT);
  const [InsertContract] = useMutation(INSERT_CONT);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  const firmData = data && data.tbl_cont_prn ? data.tbl_cont_prn[0] : null;

  console.log("Firm Data:", firmData);
  

  
 
  const [rTypeName, setRTypeName] = useState(
    firmData ? firmData.firm_sub_name_k[0].firm_sub_name_n : ""
  );
  const [firmSubName, setFirmSubName] = useState(
    firmData ? firmData.firm_sub_name[0].firm_sub_name : ""
  );

  const [mFIntId, setMFIntId] = useState(
    firmData ? firmData.firm_sub_name[0].int_ID : ""
  );

  const [contTypeName, setContTypeName] = useState(
    firmData ? firmData.get_cont_type_name[0].name : ""
  );

    const [firmMainNameK, setFirmMainNameK] = useState(
    firmData ? firmData.get_main_firm_name_k[0].firm_main_name_n : ""
  );
  
  const [rIntId, setRIntId] = useState(firmData ? firmData.int_ID : "");
  

  const [searchTerm, setSearchTerm] = useState("");
  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0);
  
  const [firmMainCodeK, setfirmMainCodeK] = useState(firmData ? firmData.firm_main_code_k : "");
  const [firmSubCodeM, setfirmSubCodeM] = useState(firmData ? firmData.firm_sub_code :"");
  const [firmSubCodeK, seFirmSubCodeK] = useState(firmData ? firmData.firm_sub_code_k : ""); 

  const [contIdSeqq, setContIdSeqq] = useState(0);
  
  const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.id_seq :"");
  const [contIdSeqK, setContIdSeqK] = useState(firmData ? firmData.id_seq_k: "");
  const [contType, setContType] = useState(firmData ? firmData.cont_type : "HAC");
  const [contTypeK, setContTypeK] = useState(firmData ? firmData.cont_type_k: "AHC");
  const [contStatus, setContStatus] = useState(firmData ? firmData.status: "PRPR");
  const [saveArr, setSaveArr] = useState(firmData ? firmData.save_arr: 1);
  const [contStatusK, setContStatusK] = useState(firmData ? firmData.k_status: "");
  const [active, setActive] = useState(firmData ? firmData.active : false);
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());
  const [currency, setCurrency] = useState(firmData ? firmData.currency: "");
  const [market, setMarket] = useState(firmData ? firmData.marketing: "");
  const [contGroup, setContGroup] = useState(firmData ? firmData.cont_group: "");
  const [dprMainM, setDprMainM] = useState(firmData ? firmData.dpr_main_code: "");
  const [dprSubM, setDprSubM] = useState(firmData ? firmData.dpr_sub_code: "");
  const [dprMainMK, setDprMainMK] = useState(firmData ? firmData.dpr_main_code_k: "");
  const [dprSubMK, setDprSubMK] = useState(firmData ? firmData.dpr_sub_code_k: "");
  const [kFIntId, setKFIntId] = useState(firmData ? firmData.k_int_ID: "");
  const [contDesc, setContDesc] = useState(firmData ? firmData.cont_desc: "");

  
  

  
  

 
  

  
  
  const convertDateFormat = (inputDate) => {
    const [year, month, day] = inputDate.split("-");
    return `${month}/${day}/${year}`;
  };
 

  //const [endDate, setEndDate] = useState(firmData ? firmData.end_date: "");
  //const formattedDate = incomingDate.split("-").reverse().join("/");

  console.log("id firm:", startDate);
  const [selectedDate, setSelectedDate] = useState(new Date('2023-12-05'));

  
  
  
  


  
  
  const close_form = messages[currentLocale].close_form;
  
  const typerec = messages[currentLocale].typerec;
  
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const cont_grp_select_holder = messages[currentLocale].cont_grp_select_holder;
  const sub_code = messages[currentLocale].sub_code;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  
 
  const cont_group_title = messages[currentLocale].cont_group_title;
  
  const managing_hotel = messages[currentLocale].managing_hotel;
  
  const room_class_tab = messages[currentLocale].room_class_tab;
  const cont_type_title = messages[currentLocale].cont_type_title;
  const select_a_agency = messages[currentLocale].select_a_agency;
  
  const cont_grp_code_title = messages[currentLocale].cont_grp_code_title;
  const cont_new_button = messages[currentLocale].cont_new_button;
  const market_code_title = messages[currentLocale].market_code_title;
  const market_title = messages[currentLocale].market_title;
  const select_market_holder = messages[currentLocale].select_market_holder;
  const currency_title = messages[currentLocale].currency_title;
  const currency_code_title = messages[currentLocale].currency_code_title;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const integration_id_title = messages[currentLocale].integration_id_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_code = messages[currentLocale].sub_department_code;
  const sub_department_name = messages[currentLocale].sub_department_name;

  

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const select_a_department_holder = messages[currentLocale].select_a_department_holder;

  const position = messages[currentLocale].position;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;
  const cont_rules_tab = messages[currentLocale].cont_rules_tab;
  const cont_season_tab = messages[currentLocale].cont_season_tab;
  const cont_reductions_tab = messages[currentLocale].cont_reductions_tab;
  const cont_guarantee_tab = messages[currentLocale].cont_guarantee_tab;
  const cont_special_con_tab = messages[currentLocale].cont_special_con_tab;
  const cont_offers_tab = messages[currentLocale].cont_offers_tab;
  const cont_pax_calcutate_tab = messages[currentLocale].cont_pax_calcutate_tab;

  const cont_management_title = messages[currentLocale].cont_management_title;
  const sales_office_title = messages[currentLocale].sales_office_title;
  const cont_detail_title = messages[currentLocale].cont_detail_title;




 

  



  


  
 

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "CSTS", lang: currentLocale},
  });

  const { loading: curLoading, error: curError, data: curData } = useQuery(GET_CUR, {
    variables: { drbtype: "CUR", lang: currentLocale},
  });

  const { loading: marLoading, error: marError, data: marData } = useQuery(GET_MAR, {
    variables: { drbtype: "SMARK", lang: currentLocale},
  });

  const { loading: firmmLoading, error: firmmError, data: firmmData } = useQuery(GET_MAIN_FIRM, {
    variables: { firmMainCode: firmMainCode},
  });

  const { loading: firmsLoading, error: firmsError, data: firmsData } = useQuery(GET_SUB_FIRM, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode},
  });

  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode},
  });

  const { loading: dprmmkLoading, error: dprmmkError, data: dprmmkData } = useQuery(GET_MAIN_DPR_MK, {
    variables: {  ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK, firmSubCodeK: firmSubCodeK},
  });

  

  const { loading: dprsmLoading, error: dprsmError, data: dprsmData } = useQuery(GET_SUB_DPR_M, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, dprMainM: dprMainM},
  });

  const { loading: dprsmkLoading, error: dprsmkError, data: dprsmkData } = useQuery(GET_SUB_DPR_K, {
    variables: {  ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK, firmSubCodeK: firmSubCodeK, dprMainMK: dprMainMK},
  });

  const { loading: fmckloading, error: fmclerror, data: fmckData } = useQuery(GET_FIRM_MAIN_COOP_K, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK},
  });

  const { loading: fsckloading, error: fsclerror, data: fsckData } = useQuery(GET_FIRM_SUB_COOP_K, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK},
  });

  //sub code for serach form table

  const { loading: fsck2loading, error: fsc2lerror, data: fsck2Data } = useQuery(GET_FIRM_SUB_COOP_K2, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });




  const { loading: fmcloading, error: fmcerror, data: fmcdata } = useQuery(GET_FIRM_MAIN_COOP, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });


  
  const filteredFirms = fmcdata && fmcdata.tbl_firm_main_coop
  ? fmcdata.tbl_firm_main_coop.filter((firm) =>
      firm.firm_main_name_n.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

  const filteredSubFirms = fsck2Data && fsck2Data.tbl_firm_sub_coop
  ? fsck2Data.tbl_firm_sub_coop.filter((firm) =>
      firm.firm_sub_name_n.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

  console.log("djhdjd", ownFirmMainCode)
  

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const currencySelectItems = curData && curData.tbl_gnl_def
  ? curData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const marketSelectItems = marData && marData.tbl_gnl_def
  ? marData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const firmMainItems = firmmData && firmmData.tbl_firm_main
  ? firmmData.tbl_firm_main.map(item => ({
      label: item.firm_name,
      value: item.firm_code,
      name: item.firm_name, 
    }))
  : [];

  const firmSubItems = firmsData && firmsData.tbl_firm_sub
  ? firmsData.tbl_firm_sub.map(item => ({
      label: item.firm_sub_name,
      value: item.firm_sub_code,
      name: item.firm_sub_name, 
    }))
  : [];

  const firmSubItems2 = firmsData && firmsData.tbl_firm_sub
  ? firmsData.tbl_firm_sub.map(item => ({
      label: item.int_ID,
      value: item.firm_sub_code,
      name: item.int_ID, 
    }))
  : [];

  const dprMainMItems = dprmmData && dprmmData.tbl_dpr_main
  ? dprmmData.tbl_dpr_main.map(item => ({
      label: item.dpr_main_name,
      value: item.dpr_main_code,
      name: item.dpr_main_name, 
    }))
  : [];

  const dprMainMKItems = dprmmkData && dprmmkData.tbl_dpr_main_coop
  ? dprmmkData.tbl_dpr_main_coop.map(item => ({
      label: item.dpr_main_name_n,
      value: item.dpr_main_code_n,
      name: item.dpr_main_name_n, 
    }))
  : [];

  const dprSubKItems = dprsmkData && dprsmkData.tbl_dpr_sub_coop
  ? dprsmkData.tbl_dpr_sub_coop.map(item => ({
      label: item.dpr_sub_name_n,
      value: item.dpr_sub_code_n,
      name: item.dpr_sub_name_n, 
    }))
  : [];

  console.log("dprsmkData:", dprsmkData);
  if (dprsmkError) {
    console.error("DPR Sub Data Error:", dprsmkError);
  }

  const dprSubMItems = dprsmData && dprsmData.tbl_dpr_sub
  ? dprsmData.tbl_dpr_sub.map(item => ({
      label: item.dpr_sub_name,
      value: item.dpr_sub_code,
      name: item.dpr_sub_name, 
    }))
  : [];

  const firmMainItemsK = fmckData && fmckData.tbl_firm_main_coop
  ? fmckData.tbl_firm_main_coop.map(item => ({
      label: item.firm_main_name_n,
      value: item.firm_main_code_n,
      name: item.firm_main_name_n, 
    }))
  : [];

  const firmSubItemsK = fsckData && fsckData.tbl_firm_sub_coop
  ? fsckData.tbl_firm_sub_coop.map(item => ({
      label: item.firm_sub_name_n,
      value: item.firm_sub_code_n,
      name: item.firm_sub_name_n,
      intIdK: item.int_ID, 
    }))
  : [];

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);

  


  

  

  
  

  
  
  
  
  /*useEffect(() => {
    if (drtData && drtData.tbl_gnl_def) {
      const selectedRoomClass = drtData.tbl_gnl_def.find(item => item.code === rTypeCode);
      if (selectedRoomClass) {
        setRTypeName(selectedRoomClass.name);
      }
    }
  }, [rTypeCode, drtData]);*/

  /*useEffect(() => {
    if (firmSubCodeK) {
      const firmSubItemsK = firmSubItemsK.find(item => item.value === firmSubCodeK);
      if (firmSubItemsK) {
        setMFIntId(firmSubItemsK.intIdK);
      }
    }
  }, [firmSubCodeK, firmSubItemsK]);
*/

/*useEffect(() => {
    if (fsckData && fsckData.tbl_firm_sub_coop) {
      const firmSubItemsK = fsckData.tbl_firm_sub_coop.find(item => item.value === firmSubCodeK);
      if (firmSubItemsK) {
        setKFIntId(firmSubItemsK.value);
      }
    }
  }, [firmSubCodeK, fsckData]);*/

  useEffect(() => {
    if (firmSubCodeK) {
      const selectedFirmSub = firmSubItemsK.find(item => item.value === firmSubCodeK);
      if (selectedFirmSub) {
        setKFIntId("");
        setKFIntId(selectedFirmSub.intIdK);
      }
    }
  }, [firmSubCodeK, firmSubItemsK]);

  useEffect(() => {
    if (firmData && firmData.dpr_main_code !== dprMainM) {
      setDprSubM("");
    }
  }, [firmData, dprMainM]);

  /*const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setContIdSeq(updatedIdSeq); 
      setContIdSeqq(updatedIdSeq);
      
     
     // setVarCode(updatedIdSeq.toString());  
      console.log(contIdSeq);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  }; */

  /*const handleUpdateIdSeq = async () => {
    const emptyFields = getEmptyFields(); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setContIdSeq(updatedIdSeq); 
        setContIdSeqq(updatedIdSeq);
        
        console.log(contIdSeq);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      // Boş alanları içeren bir uyarı mesajı oluştur
      const emptyFieldsMessage = `Lütfen şu alanları doldurun: ${emptyFields.join(', ')}`;
      console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };
  
  const validateForm = () => {
    const requiredFields = ['contType', 'currencyy']; // Gerekli alanlar listesi
  
    // Tüm gerekli alanları kontrol et
    for (const field of requiredFields) {
      if (!eval(field)) {
        return false;
      }
    }
  
    return true;
  };
  
  const getEmptyFields = () => {
    const requiredFields = ['contType', 'currency']; // Gerekli alanlar listesi
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(field);
      }
    }
  
    return emptyFields;
  }; */

 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['contType', 'currency', 'firmSubCode', 'firmMainCode',
                           'firmMainCodeK','firmMainCodeK' , 'market', 'dprMainM',
                           'dprSubM', 'dprMainMK', 'dprSubMK' ]; // Required fiels
    const customFieldNames = {
      contType: cont_type_title,
      currency: currency_title,
      firmSubCode: sub_code,
      firmMainCode: firm_code,      
      firmMainCodeK: sub_code,
      market: 'Market',
      dprMainM: main_department_code,
      dprSubM: sub_department_code,
      dprMainMK: main_department_code,
      dprSubMK: sub_department_code,


      






    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setContIdSeq(updatedIdSeq); 
        setContIdSeqq(updatedIdSeq);
        setVarCode4(updatedIdSeq);
        
        console.log(contIdSeq);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Lütfen şu alanları doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };
  
  const validateForm = (requiredFields, customFieldNames) => {
    // Tüm gerekli alanları kontrol et
    for (const field of requiredFields) {
      if (!eval(field)) {
        return false;
      }
    }
  
    return true;
  };
  
  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (contIdSeq !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
      handleinsert();  
    
    }
  }, [contIdSeq, setContIdSeq]);

 

  useEffect(() => {
    if (firmData) {
     
      seFirmSubCodeK(firmData.firm_sub_code_k);
      setRTypeName(firmData.firm_sub_name_k[0].firm_sub_name_n);
      setFirmSubName(firmData.firm_sub_name[0].firm_sub_name);
      
      setRIntId(firmData.int_ID);
      setActive(firmData.active);

      setContIdSeq(firmData.id_seq);
      setVarCode4(firmData.id_seq);
      
      setContIdSeqK(firmData.id_seq_k);
      setfirmSubCodeM(firmData.firm_sub_code);
      setfirmMainCodeK(firmData.firm_main_code_k);
      setFirmMainNameK(firmData.get_main_firm_name_k[0].firm_main_name_n);
      setSaveArr(firmData.save_arr);
      

      setContType(firmData.cont_type);
      setContTypeK(firmData.cont_type_k);
      setContTypeName(firmData.get_cont_type_name[0].name);
      setContStatus(firmData.status);
      setContStatusK(firmData.k_status);
      setStartDate(new Date(firmData.start_date));
      setEndDate(new Date(firmData.end_date));
      setContGroup(firmData.cont_group);
      setMarket(firmData.marketing);
      setCurrency(firmData.currency);
      setMFIntId(firmData.firm_sub_name[0].int_ID);
      setKFIntId(firmData.k_int_ID);
      setDprMainM(firmData.dpr_main_code);
      setDprSubM(firmData.dpr_sub_code);
      setDprMainMK(firmData.dpr_main_code_k);
      setDprSubMK(firmData.dpr_sub_code_k);
      setVarCode8(firmData.currency);
      setContDesc(firmData.cont_desc)
 
    }
  }, [firmData]);




  const actionTemplate = (rowData) => {
    const { firm_main_code_n, firm_main_name_n, int_ID } = rowData;
    
    setfirmMainCodeK(firm_main_code_n);
    
    refetch();
    
   
    return (
     
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
    
      
    );
      };
  

  

  const handleUpdateCont = () => {
    UpdateContract({
      variables: {   
        contIdSeq: contIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        firmMainCodeK: firmMainCodeK,
        firmSubCodeK: firmSubCodeK,
        contType: contType,
        contTypeK: contTypeK,
        contStatus: contStatus,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        active: active,
        contGroup: contGroup,
        market: market,
        currency: currency,
        mFIntId: mFIntId,
        dprMainM: dprMainM,
        dprSubM: dprSubM,
        dprMainMK: dprMainMK,
        dprSubMK: dprSubMK,
        kFIntId: kFIntId,
        saveArr: 1,
        contDesc: contDesc,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
        setVarCode8(currency);
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
       InsertContract({
        variables: {
          firmSubCode: firmSubCode,
          firmMainCode: firmMainCode,
          firmSubCode: firmSubCode,
          firmMainCodeK: firmMainCodeK,
          firmSubCodeK: firmSubCodeK,
          contType: contType,
          contTypeK: contTypeK,
          contStatus: contStatus,
          startDate: new Date(startDate).toLocaleDateString(),
          endDate: new Date(endDate).toLocaleDateString(),
          active: active,
          contGroup: contGroup,
          market: market,
          currency: currency,
          mFIntId: mFIntId,
          dprMainM: dprMainM,
          dprSubM: dprSubM,
          dprMainMK: dprMainMK,
          dprSubMK: dprSubMK,
          kFIntId: kFIntId,
          contIdSeq: contIdSeq,
          saveArr: 1,
          contDesc: contDesc,
        },
      })
        .then(() => {
          window.alert("Contract insert successfully!");
          setVarCode4(contIdSeq);
          setVarCode8(currency);
          fetch();
          
        })
        .catch((error) => {
          console.error("Error insert Contract:", error);
          console.error("GraphQL Errors:", error.graphQLErrors);
          console.error("Network Error:", error.networkError);
          console.error("Error Message:", error.message);
    
          // If you want to log the entire error object for inspection
          console.error("Complete Error Object:", JSON.stringify(error, null, 2));
        });
    };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;



const handleClose = () => {
  refetch();
 
  // Sayfadan ayrılmadan önce verileri temizle
  // ...

  // Daha sonra sayfadan çıkış yap
  navigate(-1);
};






const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: sales_office_title ,url:"/htl/sales-office/main" }, { label: cont_management_title ,url:"/htl/sales/price/htlagncont-list" }, { label: cont_detail_title }];

return (


    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 w-5/6">
        <nav>
          <ul className="flex border-solid rounded-md border-b outline-1">
            {items.map((item, index) => (
              <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
                {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
                {item.url ? (
                  <Link to={item.url}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="col-span-1 mr-5 flex justify-end">
     
      <button onClick={handleClose} className="text-violet-900 hover:text-violet-200 font-bold">{close_form}</button>
   
      </div>
     
  
    </div> 

    <div className="card mt-2 min-h-[40em]">

    <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_detail_tab}
            </span>
          }
          className="ml-5 flex"
        >
         <Dialog
          header="Header"
          visible={visible}
          style={{ width: '50vw' }}
           onHide={() => setVisible(false)}
>
                <p className="m-0">
                <div className=" rounded-lg ml-4 mr-4 border-violet-900 border-2 border-spacing-2 flex ">      
       <div className="container rounded-lg  p-2 mx-auto ">
      <div className=" w-32 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border border-violet-900 rounded-md"
          placeholder={search_by_firm_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      
        </div></div></div>
      <div>
      <div className="p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="350px" loading={loading}
        value={filteredFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
       // rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '30rem', maxHeight: '30rem' }}
       // onPageChange={onPageChange}
        
       
        
        >
          <Column className="font-bold text-sm" field="firm_main_code_n"  style={{ textAlign: 'center', width: '7rem' }}  header={firm_code}></Column>
          <Column className="text-sm" field="firm_main_name_n" header={<span sortable className="font-bold text-gray-900">{firm_name}</span>}></Column>
          <Column className="text-sm" field="firm_main_type_n" style={{ textAlign: 'center', width: '7rem' }} header={<span className="font-bold text-gray-900">{firm_type}</span>}></Column>
          
         
         
          <Column field="int_ID" className="font-bold text-xs" header={<span className="font-bold text-gray-900">{int_id}</span>}></Column>
          
      
          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setfirmMainCodeK(rowData.firm_main_code_n); 
                setFirmMainNameK(rowData.firm_main_name_n);
                seFirmSubCodeK("");
                setKFIntId("");                      
                setVisible(false);
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>
        
      </div>
    </div>
    
                </p>
            </Dialog>


            <Dialog
          header="Header2"
          visible={visible2}
          style={{ width: '50vw' }}
           onHide={() => setVisible2(false)}
>
                <p className="m-0">
                <div className=" bg-slate-400 flex ">      
       <div className="container bg-slate-400 p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_firm_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      
        </div></div></div>
      <div>
      <div className="p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="350px" loading={loading}
        value={filteredSubFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
       // rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '30rem', maxHeight: '30rem' }}
       // onPageChange={onPageChange}
        
       
        
        >
          <Column className="font-bold text-sm" field="firm_main_code_n"  style={{ textAlign: 'center', width: '8rem' }}  header={firm_code}></Column>
          <Column className="text-sm" field="firm_sub_code_n" style={{ textAlign: 'center', width: '7rem' }}header={<span sortable className="font-bold text-gray-900">{firm_name}</span>}></Column>
          <Column className="text-sm" field="firm_sub_name_n" style={{ textAlign: 'center', width: '20rem' }} header={<span className="font-bold text-gray-900">{firm_type}</span>}></Column>
          
         
         
          <Column field="int_ID" className="font-bold text-xs" style={{ textAlign: 'center', width: '7rem' }}header={<span className="font-bold text-gray-900">{int_id}</span>}></Column>
          
      
          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setfirmMainCodeK(rowData.firm_main_code_n);                 
                seFirmSubCodeK(rowData.firm_sub_code_n);
                setKFIntId("");
                                     
                setVisible2(false);
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>
        
      </div>
    </div>
    
                </p>
            </Dialog>

<Fieldset>
      
      <p className="m-0 flex font-medium ">
              
       <div className="flex gap-4">
        <div className="w-20 gap-3">
        <label className="block font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {<FormattedMessage id="cont_id_title" />}</label>
        <InputText className="h-11  w-full" 
        id="username" value={contIdSeq}
        onChange={(e) => setContIdSeq(e.target.value)}
        />
      </div>

      <div className="w-2/12 h-10 gap-3">
        <label                
         htmlFor="firmname"> {<FormattedMessage id="cont_start_date_title" />}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      

      <div className="w-2/12 gap-3">
        <label                
         htmlFor="firmname"> {<FormattedMessage id="cont_end_date_title" />}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      

      <div className="w-20 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {typerec}</label>
        <InputText className="w-full h-11" 
        id="firmname" value={contType} 
        onChange={(e) => setContType(e.target.value)} />
      </div>
      <div className="w-2/12 h-3 p-inputtext-sm flex-column gap-3">
        <label styleClass="w-full h-3" className="block  font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="firmname"> {cont_type_title}</label>
        <InputText className="w-full h-11 " 
        id="firmname" value={contTypeName} 
        onChange={(e) => setContTypeName(e.target.value)} />
      </div>
    
    
  <div>
    <label htmlFor="roomClassDropdown" className="col-span-3 w-fit block font-medium text-gray-700">
      {position}
    </label>
    <Dropdown
      className="h-11  w-full rounded-md" // Bu satır eklenmiştir
      style={{ width: '100%' }}
      dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>}
      value={contStatus}
      options={roomClassSelectItemsB}
      onChange={(e) => setContStatus(e.value)}
      placeholder={position}
    />
  </div>
  
  <div className="ml-5 flex-col font-medium  flex justify-content-center">      
    <label htmlFor="firmtype" 
  className=" flex-col w-1/12  ml-0 mb-4 align-items-center block font-medium text-gray-950">{<FormattedMessage id="statusrec" />} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setActive(e.value)} checked={active === true} />
          <label htmlFor="ingredient1" className="ml-2">{<FormattedMessage id="activerec" />}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setActive(e.value)} checked={active === false} />
          <label htmlFor="ingredient2" className="ml-2">{<FormattedMessage id="inactiverec" />}</label>
      </div>
      </div>
      </div>  
      </div>
       
      </p>
     
      
      <p className="my-0 mt-5 flex font-medium ">
                  
              <div className="flex gap-4">
               <div className="w-20 gap-3">
         <label className="block font-medium text-gray-950 justify-content-center gap-4"
          htmlFor="username">  {<FormattedMessage id="cont_id_title" />}</label>
         <InputText className="h-11  w-full" 
         id="username" value={contIdSeq}
         onChange={(e) => setContIdSeq(e.target.value)}
         />
       </div>

       <div className="w-60 gap-3">
         <label className="block font-medium text-gray-950 justify-content-center gap-4"
          htmlFor="username">  {"Cont Desc"}</label>
         <InputText className="h-11  w-full" 
         id="username" value={contDesc}
         onChange={(e) => setContDesc(e.target.value)}
         />
       </div>
 
       <div className="w-20 gap-3">
         <label className="block font-medium text-gray-950 justify-content-center gap-4"
          htmlFor="username">  {cont_grp_code_title}</label>
         <InputText className="h-11  w-full" 
         id="username" value={contGroup}
         onChange={(e) => setContGroup(e.target.value)}
         />
       </div>

       <div>
     <label htmlFor="roomClassDropdown" className=" col-span-3 w-fit block font-medium text-gray-700">
       {cont_group_title}
     </label>
     <Dropdown
       className="h-11 w-full rounded-md" // Bu satır eklenmiştir
       style={{ width: '100%' }}
       showClear
       value={market}
       options={marketSelectItems}
       onChange={(e) => setMarket(e.value)}
       placeholder={cont_grp_select_holder}
     />
   </div>

   

   <div className="w-20  gap-3">
         <label className="block  font-medium text-gray-950 justify-content-center gap-4"
          htmlFor="username">  {market_code_title}</label>
         <InputText className="h-11  w-full" 
         id="username" value={contGroup}
         onChange={(e) => setContGroup(e.target.value)}
         />
       </div>

       <div>
     <label htmlFor="roomClassDropdown" className=" col-span-3 w-fit block font-medium text-gray-700">
       {market_title}
     </label>
     <Dropdown
       className="h-11 w-full rounded-md" 
       style={{ width: '100%' }}
       value={market}
       options={marketSelectItems}
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>}
       onChange={(e) => setMarket(e.value)}
       placeholder={select_market_holder}
     />
   </div>


   <div className="w-20 gap-3">
         <label className="block font-medium text-gray-950 justify-content-center gap-4"
          htmlFor="username">  {currency_code_title}</label>
         <InputText className="h-11  w-full" 
         id="username" value={currency}
         onChange={(e) => setCurrency(e.target.value)}
         />
       </div>
      

   <div>
     <label htmlFor="roomClassDropdown" className=" col-span-3 w-fit block font-medium text-gray-700">
       {currency_title}
     </label>
     <Dropdown
       className="h-10 text-justify  fixed w-2/12 block rounded-md" // Bu satır eklenmiştir
       inputStyle={{width: "50px"}}
       style={{ width: '100%' }}
       
       value={currency}
       options={currencySelectItems}
       onChange={(e) => setCurrency(e.value)}
       placeholder={"Contrat Para Birimi"}
     />
   </div>
 
       </div>
        
       </p>

         
         </Fieldset>
         
         <Fieldset >  
                  
         <p className="my-0 font-medium ">
              

              <div className="flex gap-4">


              <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
        <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {<FormattedMessage id="main_code" />}</label>
        <InputText className="w-full" 
        id="username" value={firmMainCode} 
        />
      </div>
    
      <div>
    <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
      {firm_name}
    </label>
    <Dropdown
      className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
      style={{ width: '384px' }} 
      dropdownIcon={"d"}
      value={firmMainCode}
      options={firmMainItems}
      
      placeholder={select_a_bed_type}
    />
  </div>

      <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
        <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {sub_code}</label>
        <InputText className="w-full" 
        id="username" value={firmSubCode} 
        />
      </div>
    
      <div>
      <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
    <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
      {firm_sub_name}
    </label>
    <Dropdown
      className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
      style={{ width: '384px' }} 
      dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
      value={firmSubCode}
      options={firmSubItems}
      
      placeholder={select_a_bed_type}
    />

 
    </div>
    
    </div>
    <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
         <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {integration_id_title}</label>
         <InputText className="h-11 w-full" 
         id="username" value={mFIntId} 
         />
         </div>
  </div>
  
  
           <div className="flex gap-4">
           <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
           htmlFor="username">  {main_department_code}</label>
           <InputText className="w-full" 
          id="username" value={dprMainM} 
          onChange={(e) => setDprMainM(e.value)}
           />
          </div>

         <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {main_department_name}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '384px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={dprMainM}
         options={dprMainMItems}
         onChange={(e) => setDprMainM(e.value)}
         placeholder={select_a_department_holder}
         />
       </div>
       <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
        <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {sub_department_code}</label>
         <InputText className="w-full" 
         id="username" value={dprSubM}
         onChange={(e) => setDprSubM(e.value)}
         />
         </div>
         
         <div>
          <div className="w-2/4 p-inputtext-sm  flex-column gap-3">
            <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
              {sub_department_name}
              </label>
              <Dropdown
              className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
              style={{ width: '384px' }} 
              dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>}
              value={dprSubM}
              options={dprSubMItems}
              onChange={(e) => setDprSubM(e.value)}
              placeholder={select_a_department_holder}
              />
              </div>
              </div>
              
              <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
                <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
                 htmlFor="username">  {integration_id_title}</label>
                 <InputText className="w-full" 
                 id="username" value={firmSubCode} 
                 />
                 </div>
                 </div>



  
    </p>
    </Fieldset>

    <Fieldset >  
                  
                  <p className="my-0 font-medium ">
                       
                   
                 
         
                   <div className="flex gap-4">
         
                   <div className="w-1/10 gap-3">
            <label className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">
            {firm_code}
           </label>
          <InputText
             className="h-11 w-full"
             id="username"
             value={firmMainCodeK}
             onChange={(e) => setfirmMainCodeK(e.target.value)}  // Değişiklik burada
               />
            </div>

          

              <div>
          <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
            <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
              {firm_name}
              </label>
              <Dropdown
              className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
              style={{ width: '384px' }} 
              dropdownIcon={ "d"}
              value={firmMainCodeK}
              options={firmMainItemsK}
              onChange={(e) => setfirmMainCodeK(e.value)}
              placeholder={select_a_agency}
              />
              </div>
              </div>
              <button 
              onClick={() => setVisible(true)} 
             className="cursor-pointer mt-5  mr-5 flex items-center justify-start"
             >
              <svg 
               className="w-6 h-6 text-gray-800 dark:text-white" 
               aria-hidden="true" 
               xmlns="http://www.w3.org/2000/svg" 
               fill="none" 
              viewBox="0 0 20 20"
                >
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
            </svg>
           </button>

            <div className="w-1/10 gap-3">
            <label className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">
            {sub_code}
           </label>
          <InputText
             className="h-11 w-full"
             id="username"
             value={firmSubCodeK}
             onChange={(e) => seFirmSubCodeK(e.target.value)} 
               />
            </div>

            <div>
          <div className="w-1/4 p-inputtext-sm flex-column ">
            <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
              {firm_sub_name}
              </label>
              <Dropdown
              className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
              style={{ width: '384px' }} 
              dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
               <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
                </svg>}
              value={firmSubCodeK}
              options={firmSubItemsK}
              onChange={(e) => seFirmSubCodeK(e.value)}
              placeholder={select_a_agency}
              />
              </div>
              </div>

            <button 
              onClick={() => setVisible2(true)} 
             className="cursor-pointer mt-5 flex items-center m-0 text-violet-700 hover:text-violet-400 "
             >
              <svg 
               className="w-6 h-6 text-gray-800 dark:text-white" 
               aria-hidden="true" 
               xmlns="http://www.w3.org/2000/svg" 
               fill="none" 
              viewBox="0 0 20 20"
                >
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
            </svg>
           </button>

           <div className="w-1/10 gap-3">
            <label className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">
            {integration_id_title}
           </label>
          <InputText
             className="h-11 w-full"
             id="username"
             value={kFIntId}
             onChange={(e) => setKFIntId(e.target.value)}  // Değişiklik burada
               />
            </div>
            
                       
       
         </div>

         <div className="flex gap-4">
           <div className="w-1/11 p-inputtext-sm  flex-column gap-3">
           <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
           htmlFor="username">  {main_department_code}</label>
           <InputText className="w-full" 
          id="username" value={dprMainMK} 
          onChange={(e) => setDprMainMK(e.value)}
           />
          </div>

         <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {main_department_name}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '384px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={dprMainMK}
         options={dprMainMKItems}
         onChange={(e) => setDprMainMK(e.value)}
         placeholder={select_a_department_holder}
         />
       </div>
       <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
        <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
         htmlFor="username">  {sub_department_code}</label>
         <InputText className="w-full" 
         id="username" value={dprSubMK}
         onChange={(e) => setDprSubMK(e.value)}
         />
         </div>
         
         <div>
          <div className="w-2/4 p-inputtext-sm  flex-column gap-3">
            <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
              {sub_department_name}
              </label>
              <Dropdown
              className="h-11 m2-10 w-56 rounded-md" // Bu satır eklenmiştir
              style={{ width: '384px' }} 
              dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>}
              value={dprSubMK}
              options={dprSubKItems}
              onChange={(e) => setDprSubMK(e.value)}
              placeholder={select_a_department_holder}
              />
              </div>
              </div>
              
              <div className="w-1/6 ml-5 p-inputtext-sm  flex-column gap-3">
                <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
                 htmlFor="username">  {integration_id_title}</label>
                 <InputText className="w-full" 
                 id="username" value={firmSubCode} 
                 />
                 </div>
                 </div>
         <Divider align="right" >
                  <div className=" align-items-center">
                   
            
             <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateCont}
      >
        {updaterec}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateIdSeq}
      >
        {cont_new_button}
      </button>
             </div>
         </Divider>      
             
             </p>
             </Fieldset>
        
  
        
  
  </TabPanel>

  <TabPanel
  header={
    <span
      className={`font-bold hover:border-b-2 cursor-pointer border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
        activeTab === 1
          ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300'
          : 'text-sienna-700'
      } ${saveArr < 1 ? 'text-gray-500' : 'hover:border-purple-500'}`}
    >
      {cont_season_tab}
    </span>
  }
  className="ml-5 flex"
  disabled={saveArr < 1}
>

        
        <HtlAgnSeasonPrice/>
            
   

  </TabPanel>

  <TabPanel
  header={
    <span
      className={`font-bold hover:border-b-2 cursor-pointer border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
        activeTab === 2
          ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300'
          : 'text-sienna-700'
      } ${saveArr < 1 ? 'text-gray-500' : 'hover:border-purple-500'}`}
    >
      {"Ek Sezon"}
    </span>
  }
  className="ml-5 flex"
  disabled={saveArr < 1}
>
          <br></br>

         
      



  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 3 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_offers_tab}
            </span>
          }
          className="ml-5 flex"
        >
          
     <HtlAgnOffres/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 4 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_rules_tab}
            </span>
          }
          className="ml-5 flex"
        >
           

   
       

<div className="card  justify-content-center">
<div className="w-1/12 p-inputtext-sm flex-column gap-3">
            <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
             htmlFor="firmname"> {<FormattedMessage id="cont_type_title" />}</label>
            <InputText className="w-full" 
            id="firmname" value={contType} 
            />
          </div>
    
         
          </div> 

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 5 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_guarantee_tab}
            </span>
          }
          className="ml-5 flex"
        >
          
     <HtlAgnGuarantee/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 6 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Kontjanlar"}
            </span>
          }
          className="ml-5 flex"
        >
          
     <HtlAgnQuota/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 7 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Free Rooms"}
            </span>
          }
          className="ml-5 flex"
        >
          
     <HtlAgnFreeRooms/>
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 8 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_special_con_tab}
            </span>
          }
          className="ml-5 flex"
        >
          
     
         

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 9 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {cont_pax_calcutate_tab}
            </span>
          }
          className="ml-5 flex"
        >
          
     
         

  </TabPanel>

</TabView>
  </div>
  </div>
);
};

export default HtlAgnContractEdit;
